export default __webpack_public_path__ + "f8f6d02e0ce78997194ceb29e58c6ebf.pdf";